import { STATUS } from "#candidate/constants"
import CandidateStatusDate from "./CandidateStatusDate"

export default function CandidateStatusBoss() {
	return (
		<CandidateStatusDate
			label={"Agendar Entrevista"}
			title="Agendar Entrevista Jefe"
			status={STATUS.SCHEDULED_BY_BOSS}
			message="Selecciona la fecha y hora para la entrevista"
		/>
	)
}
